<template>
  <transition name="slide">
    <div
      v-if="checked && !cookiesAccepted"
      class="fixed bottom-0 left-0 right-0 bg-gravaawarmgray text-white p-4 z-50 shadow-lg">
      <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
        <p class="mb-0 text-sm sm:text-base max-w-3xl">
          We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking "Accept", you consent to our use of cookies.
        </p>
        <div class="flex flex-col items-center sm:flex-row gap-2 w-full sm:w-auto">
          <div @click="declineCookies" class="sm:w-auto text-black px-4 cursor-pointer" aria-label="Decline Cookies">
            Decline
          </div>
          <UiRippleButton @click="acceptCookies" class="w-full sm:w-auto" aria-label="Accept Cookies">
            Accept
          </UiRippleButton>
         
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useCookie } from '#app'
import { useCookieStore } from '@/stores/cookieStore'
import { useCartStore } from '@/stores/cartStore'
const { proxy } = useScriptGoogleTagManager()


const cartStore = useCartStore();



const cookieStore = useCookieStore()
const cookieConsent = useCookie('gravaaCookieConsent', { default: () => null })
const cookiesAccepted = ref(cookieConsent.value === 'accepted')
const checked = ref(false)

const acceptCookies = () => {
  cookieConsent.value = 'accepted'
  cookiesAccepted.value = true
  cookieStore.setConsent(true)
}

const declineCookies = () => {
  cookieConsent.value = 'declined'
  cookiesAccepted.value = true
  cookieStore.setConsent(false)
}

const startTracking = () => {
   // Initialize GTM, Analytics, etc. here
  console.log('Cookies Accepted, reporting to GTM.');

  // WISEPOPS
    (function(w, i, s, e) {
        window[w] = window[w] || function() {
            (window[w].q = window[w].q || []).push(arguments);
        };
        window[w].l = Date.now();
        s = document.createElement('script');
        e = document.getElementsByTagName('script')[0];
        s.defer = 1;
        s.src = i;
        e.parentNode.insertBefore(s, e);
    })('wisepops', 'https://wisepops.net/loader.js?v=3&h=C4bFK9xzmN');

  try{
  proxy.dataLayer.push({
      event: 'cookiePreference',
      eventAction: 'submit',
      eventValue: 'enabled'
  })
  } catch (error) {
    console.error('Error pushing to dataLayer:', error);
  }

  // WISEPOPS
    (function(w, i, s, e) {
        window[w] = window[w] || function() {
            (window[w].q = window[w].q || []).push(arguments);
        };
        window[w].l = Date.now();
        s = document.createElement('script');
        e = document.getElementsByTagName('script')[0];
        s.defer = 1;
        s.src = i;
        e.parentNode.insertBefore(s, e);
    })('wisepops', 'https://wisepops.net/loader.js?v=3&h=C4bFK9xzmN');

  
  
  //proxy.dataLayer.push({ event: 'test', value: 1 })
}

onMounted(() => {
  checked.value = true
  

  if (cookieConsent.value === 'accepted') {
    cookiesAccepted.value = true
    cookieStore.setConsent(true)
    startTracking();
    console.log('mounting - cookies accepted');
    
    //const cartCookie = useCartCookie();
    //cartCookie.value = cartStore.cart.id;
  }

  cartStore.initCart();


})

watch(cookiesAccepted, (newVal) => {
  if (newVal && cookieConsent.value === 'accepted') {
    startTracking();
    const cartCookie = useCartCookie();
    if (cartStore.cart?.id) {
      cartCookie.value = cartStore.cart.id;
    }


  }
})
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateY(100%);
}
</style>
